import React, { useState, useEffect } from 'react';

import { APP_URL } from 'types';
import { SideNavLink } from 'carbon-components-react';
import { Add16, Dashboard16, Time16 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';
export const LeftNavCommonMenuItem: React.FC<{}> = () => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      {/* Dashboard */}
      <SideNavLink
        aria-current={pathname === APP_URL.DASHBOARD ? 'page' : undefined}
        renderIcon={Dashboard16}
        onClick={() => history.push(`${APP_URL.DASHBOARD}`)}
      >
        Dashboard
      </SideNavLink>
      {/* My enquiries */}
      <SideNavLink
        aria-current={
          pathname === APP_URL.ENQUIRIY_HISTORY ? 'page' : undefined
        }
        renderIcon={Time16}
        onClick={() => history.push(`${APP_URL.ENQUIRIY_HISTORY}`)}
      >
        My enquiries
      </SideNavLink>
      {/* Lodge new enquiry */}
      <div className="divider" />
      <SideNavLink
        aria-current={
          pathname === APP_URL.LODGE_NEW_ENQUIRY ? 'page' : undefined
        }
        renderIcon={Add16}
        onClick={() => history.push(`${APP_URL.LODGE_NEW_ENQUIRY}`)}
      >
        Lodge new enquiry
      </SideNavLink>
    </>
  );
};

export default LeftNavCommonMenuItem;
